<div class="bg-white min-w-52 w-full h-full">
	<div
		class="p-4 rounded-t-lg border border-b-0 border-gray-200 flex justify-between items-center"
	>
		<h3 class="text-xl font-medium capitalize">Documents</h3>
		<ui-button
			ariaLabel="Add Documents"
			preset="EXTRA_LOW_EMPHASIS"
			icon="plus"
			(click)="openDocumentDrawer()"
		/>
	</div>
	<app-matter-package-document-list
		[withinEnvelopView_]="true"
		[packageId_]="packageId_()"
		(documentToRender_)="documentToRender_.emit($event)"
	/>
</div>
